export const ENVIRONTMENT = process.env.NEXT_PUBLIC_ENV as
  | 'local'
  | 'stg'
  | 'prod'
  | undefined

export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_MAX_LENGTH = 20
